import styles from './styles.module.scss';

import React, {useEffect, useRef, useState} from "react";
import {slugify, slugifyWithDash, ucFirst} from "../../helpers/helpers";

const ColorOption: React.FC = (props: { name: string, id: string, value: string, onChange: any, checked: boolean }) => {

    const id = props.id.replace('gid://shopify/ProductVariant/', '')

    let thumb_img = `${slugify(props.value)}-new.png`;
    if (window.scs_force_custom === true) {
        thumb_img = `custom-${slugifyWithDash(props.value).toLowerCase()}.png`;
    }

    return (
        <div className={styles.color_option}>
            <label htmlFor={`color-${id}`}><input type="radio" onChange={props.onChange} name={props.name}
                                                  value={props.value} id={`color-${id}`} data-id={id} checked={props.checked} />
                <img src={`https://cdn.shopify.com/s/files/1/0732/5909/0212/files/${thumb_img}?v=2`} alt={`${props.value}`} className={`${styles.color_img}`}/>
                <div className={`${styles.title}`}>{props.value}</div>
            </label>
        </div>
    );
};

export default ColorOption;